import { DATA_TESTID, Text_INTERNAL } from "../Text_INTERNAL";
import type { TextInternalProps } from "../Text_INTERNAL";

const styleProps = {
  size: "text-sm",
};

export interface LabelXsPlusProps extends TextInternalProps {
  "data-testid"?: string;
}

export const LabelXsPlus = ({
  weight = "normal",
  color,
  textTransform,
  truncate,
  as = "span",
  [DATA_TESTID]: dataTestId,
  children,
}: LabelXsPlusProps) => {
  const props = {
    ...styleProps,
    dataTestId,
    weight: `font-${weight}`,
    color,
    textTransform,
    truncate,
  };

  return (
    <Text_INTERNAL as={as} {...props}>
      {children}
    </Text_INTERNAL>
  );
};
